import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic,Progress  } from 'antd';
import {balanceOf,signer, transfer} from '../../utils/ethers'
import StripedProgressBar from '../../components/progress/Progress'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import {useNavigate} from "react-router-dom";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined,DownOutlined,ExportOutlined,CheckCircleOutlined,StopOutlined,ClockCircleOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import {addPledgeBuy, getPledgeCanBuy, getPledgeIndex,unPledgeBuy} from "../../api";
import CountUp from "react-countup";
import { CSSTransition } from 'react-transition-group';
const { Countdown } = Statistic;
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Staking = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)


    const [needValue,setNeedValue] = useState("")
    const [needUsdt,setNeedUsdt] = useState("")
    const [needToken,setNeedToken] = useState("")
    const [min,setMin] = useState(100)
    const [token_n,setTokenN] = useState(0)
    const [usdt_n,setUsdtN] =useState(0)
    const [tokenPrice,setTokenPrice] = useState(0)
    const [days,setDays] =useState(30)
    const [rate,setRate] = useState(0.80)
const [needBnb,setNeedBnb] = useState("")
const [small,setSmall] = useState("")
    const [pledgeRecords1,setPledgeRecords1] = useState([])
    const [pledgeRecords2,setPledgeRecords2] = useState([])
    const [pledgeRecords3,setPledgeRecords3] = useState([])
    const [poolToken1,setPoolToken1] = useState("")
    const [poolUsdt1,setPoolUsdt1] = useState("")
    const [poolToken2,setPoolToken2] = useState("")
    const [poolUsdt2,setPoolUsdt2] = useState("")
    const [poolToken3,setPoolToken3] = useState("")
    const [poolUsdt3,setPoolUsdt3] = useState("")
    const [big,setBig] = useState("")
    const [level ,setLevel] = useState(0)

    const [allBonusPledgeCcer,setAllBonusPledgeCcer] = useState(0)
    const [allPledgeCcer,setAllPledgeCcer] = useState(0)

  const [tab, setTab] = useState(0);
     const [jing, setJing] = useState(0);
      const [dong, setDong] = useState(0);
    

  const [isShowMenu,setIsShowMenu] = useState(false);

    
    const [isLock,setIsLock]=useState(false)

    const [showJoin,setShowJoin] = useState(false)
    const [showJoin0,setShowJoin0] = useState(false)
    const [showJoin1,setShowJoin1] = useState(false)
    const [showJoin2,setShowJoin2] = useState(false)

    const [tabIndex ,setTabIndex] = useState(2)

const tabs = [
  t('pl.添加算力'),
  t('pl.质押记录'),
  t('pl.团队数据')
];

const _getDays = (e,p) =>{
    if(props.address.length === 0){
        return false
    }
        setRate(p)
        setDays(e)
    
}






    
    const _rand= () =>{
        message.error(t('g.暂未开始'))
       return
        // if(props.address.length<=0) return false
        if(props.address.length<=0){
            message.error(t('g.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('g.您还未绑定钱包，请绑定激活钱包地址'))
            return false
        }
        if(tokenPrice == 0){
             message.error(t('pl.请输入价值数量'))
            return false
        }

        if(min==""){
            return
        }
      
        if(!needValue){
            message.error(t('pl.请输入价值数量'))
            return false
        }
        if(needValue.length<=0){
            message.error(t('pl.请输入价值数量'))
            return false
        }
        if(parseFloat(needValue)<parseFloat(min)){
            message.error(t('pl.不能小于最小量')+":"+min)
            return false
        }
       
        if(tabIndex==1){
            if(parseFloat(needToken)>parseFloat(token_n)){

                message.error("SPACEX"+t('pl.可用数量不足'))
                return false
            }
        }else if(tabIndex ==2){
            // if(parseFloat(needUsdt)>parseFloat(usdt_n)){

            //     message.error("USDT"+t('stake.可用数量不足'))
            //     return false
            // }
            if(parseFloat(needToken)>parseFloat(token_n)){

                message.error("SPACEX"+t('pl.可用数量不足'))
                return false
            }
        }else if(tabIndex ==3){
            if(parseFloat(needUsdt)>parseFloat(usdt_n)){

                message.error("USDT"+t('stake.可用数量不足'))
                return false
            }
            if(parseFloat(needToken)>parseFloat(token_n)){

                message.error("SPACEX"+t('stake.可用数量不足'))
                return false
            }
        }else{
            return
        }
            
        




        if(isLock) return false;
        setIsLock(true)
        signer(props.address).then(res=>{
            addPledgeBuy({address:props.address,value:parseFloat(needValue),tab_index:String(tabIndex),pass:res.pass,days:String(days)}).then(res=>{
                if(res.code===0){
                    message.success(res.msg)
                }else{
                    message.error(res.msg)
                }
                closeAll()
                setNum(num+1)
            },error=>{
                setIsLock(false)
                message.error(res.msg)
            })

        },error=>{
            message.error(error)
            setIsLock(false)
        })



    }



    const _getPledgeCcerIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getPledgeIndex().then(res=>{
            if(res.code === 0 ){

                
               setTokenPrice(res.data.price)
               setUsdtN(res.data.usdt_n)
               setTokenN(res.data.token_n)
               setMin(res.data.min)
                if(res.data.list1 != null){
                    setPledgeRecords1(res.data.list1)
                }

                if(res.data.list2 != null){
                    setPledgeRecords2(res.data.list2)
                }

                if(res.data.list3 != null){
                    setPledgeRecords3(res.data.list3)
                }
                setSmall(res.data.small)
                setBig(res.data.big)
                setLevel(res.data.level)
                setJing(res.data.jing)
                setDong(res.data.dong)

                setPoolToken1(res.data.pool_token1)
                setPoolUsdt1(res.data.pool_usdt1)

                setPoolToken2(res.data.pool_token2)
                setPoolUsdt2(res.data.pool_usdt2)

                setPoolToken3(res.data.pool_token3)
                setPoolUsdt3(res.data.pool_usdt3)
                // if(res.data.minted >0){
                //     let _par =  Math.round(res.data.minted / 5000000 *10000)/100
                //     if(_par >100){
                //         _par = 100
                //     }
                //     setPar(_par)
                // }
                

                    

                    //console.log(_par)
                    

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }

    const hui = (_orderNum,_state,_etime,path) =>{
       
        if(path !=2){
            message.error(t('pl.此订单不可赎回'))
            return
        }

        
        if (_state != 0){
            return false
        }

        var time1 = Date.parse(new Date()) / 1000;

        if(tabIndex==2){
            console.log(time1)
            console.log(_etime)
              if(time1 < _etime){
                    message.error(t('pl.未到解锁时间'))
                        return false
                }
        }
      
        
     
     
        if(isLock) return false;
        setIsLock(true)
        signer(props.address).then(res=>{
            unPledgeBuy({address:props.address,pass:res.pass,orderNum:String(_orderNum),tab_index:String(tabIndex)}).then(res=>{
                if(res.code===0){
                    message.success(res.msg)
                }else{
                    message.error(res.msg)
                }
                setIsLock(false)
           
                setNum(num+1)
            },error=>{
                setIsLock(false)
                message.error(res.msg)
            })

        },error=>{
            message.error(error)
            setIsLock(false)
        })
    }

    function getToken(_usdt){
        
        let _token =0
        _token =parseInt(_usdt / tokenPrice * 100000 ) / 100000
        return _token
    }

    const _getPoolToken = (e) =>{
        console.log(e)
        if(tabIndex ==1){
            setNeedValue(e)
            setNeedToken(getToken(e))
            return
        }
        if(tabIndex ==2){
            setNeedValue(e)
            setNeedToken(getToken(e))
            // setNeedValue(e)
            // setNeedUsdt(e * 0.5)
            // setNeedToken(getToken(e * 0.5))
            return
        }
         if(tabIndex ==3){
            setNeedValue(e)
            setNeedUsdt(e * 0.5)
            setNeedToken(getToken(e * 0.5))
            return
        }
       
    }

  
    const closeAll = () =>{
      
        setNeedUsdt("")
        setNeedToken("")
        setNeedValue("")
        setIsLock(false)
    }

   



    useEffect(() => {
            window.scrollTo(0, 0)
            _getPledgeCcerIndex()

    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
       
        <Head/>
                    <div className=' plbg  w-full lg:w-1/3 md:w-1/3 sm:1/2  px-0 pt-12 text-white flex flex-col z-10'>
                        {/*  */}
                        <div className='w-full lg:w-1/3 px-0   min-h-[93px]  flex flex-row  '>
                            {/* <div className=' w-full lg:w-1/3 md:w-1/3 sm:1/2 min-h-[203px]  absolute '>
                                
                            </div> */}
                            <div className='w-[57%] pl-4 flex flex-col z-40'>
                                {/* <img className='mt-5  '  src={require('../../assets/task/title.png')} style={{"width":"406px"}}></img>
                                <span className='mt-[2px] text-text1 text-[9px]' >{t('tr.完成交易考核，解锁释放额度')}</span> */}
                              
                               
                                
        
                            </div>
                            
                        </div>

                        {/*  */}
                        <div className="stake-tab-wrap mx-4 mb-2">
                            {tabs.map((item, index) => (
                                <div
                                key={index}
                                onClick={() => setTab(index)}
                                className={`stake-tab-item ${
                                    tab === index ? "active" : ""
                                }`}
                                >
                                {item}
                                </div>
                            ))}

                            <div
                                className="stake-tab-indicator"
                                style={{
                                transform: `translateX(${tab * 100}%)`
                                }}
                            />
                            </div>
                        {/*  */}


                        {
                            tab==0?(
                                <>
                                    {/* <div className='mx-4  mt-3   h-[60px]  flex flex-row justify-between items-center'>
                            
                            
                                        <div className=' flex flex-row justify-center items-center w-[168px] px-2 py-2 SWAPbg1'>
                                            <img className='mr-2 '  src={require('../../assets/task/icon1.png')} style={{"width":"30px"}}></img>
                                            <div className='flex flex-col justify-center items-start'>
                                                <span className='text-gray-400 text-[9px]'>{t('pl.当前总质押')}</span>
                                                <span className=' text-base'>$<CountUp start={0} end={1220} duration="1" decimals={2} /></span>
                                            </div>
                                        </div>
                                        <div className=' flex flex-row justify-center items-center w-[168px] px-2 py-2 SWAPbg1'>
                                            <img className='mr-2 '  src={require('../../assets/task/icon1.png')} style={{"width":"30px"}}></img>
                                            <div className='flex flex-col justify-center items-start'>
                                                <span className='text-gray-400 text-[9px]'>{t('pl.累积挖矿收益')}</span>
                                                <span className=' text-base'>$<CountUp start={0} end={1220} duration="1" decimals={2} /></span>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className='mx-4  mt-3 pl-3 pr-3 pt-4 plbg1 min-h-[260px]  flex flex-col justify-start'>
                                        <div className='w-full flex flex-row justify-center'>
                                            <span className='mt-1 text-text1 text-[11px] leading-[11px]'>{t('pl.质押')} $SPACEX</span>
                                        </div>
                                            
                                        
                                        <div className='mt-2 w-full flex flex-col items-center relative'>
                                            {/* <img className='-bottom-5  absolute z-[40]'  src={require('../../assets/ipo/arr.png')} style={{"width":"30px"}}></img> */}
                                            <div className="w-full min-h-[30px]
                                                    relative inline-flex flex-col h-4  justify-start 
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <div className='w-full z-10 flex flex-row justify-between items-center'>
                                                
                                                    <span className='text-[10px] leading-[10px] text-gray-400'>{t('tr.当前余额')}: <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={token_n}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /></span>
                                                    <span className='text-[10px] leading-[10px] text-gray-400'>{t('pl.价值')}:$ <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={token_n * tokenPrice}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /></span>
                                                </div>
                                            
                                            
                                            
                                            </div>
                                        </div>

                                        <div className='mt-2 w-full flex flex-col items-center relative'>
                                            <div className="w-full min-h-[50px]
                                                    relative inline-flex flex-row h-4  justify-between items-center
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <span className='text-[10px] leading-[10px] text-text1 z-10'>{t('pl.输入质押价值')}</span>
                                                <div className=' w-1/2    flex flex-row justify-center items-center  z-10'>
                                                                <input  type="number" onInput={(e)=>_getPoolToken(e.target.value)} value={needValue} placeholder={t('mint.输入最低')+" $100"}  className='placeholder:text-[10px] w-full text-base text-white input1 text-right '  />
                                                        </div>
                                            </div>
                                        </div>
                    
                                        <div className='mt-2 w-full flex flex-col items-center relative'>
                                            <div className="w-full min-h-[50px]
                                                    relative inline-flex flex-col h-4  justify-start 
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <div className='w-full z-10 flex flex-row justify-between items-center'>
                                                    <span className='text-[10px] leading-[10px] text-text1'>{t('pl.需质押')}</span>
                                                    {/* <span className='text-[9px] leading-[9px] text-gray-400'>BALANCE: 0.00 SPACEX</span> */}
                                                </div>
                                            <div className='mt-1 w-full z-10 flex flex-row justify-between items-center'>
                                                    <div className="w-[100px]
                                                        relative inline-flex h-5 items-center justify-start
                                                        px-2 py-3 text-white text-[10px]  tracking-wider
                                                        [--cut:3px] [--border:1px]
                                                        before:absolute before:inset-0 before:bg-gray-800
                                                        before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                        after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                                        after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    ">
                                                        <img className='  z-10' alt='logo' src={require('../../assets/ipo/bnb.png')} style={{"width":"17px"}}></img>
                                                        <span className="ml-1 z-10 text-[12px] text-[#F9B514]">SPACEX</span>
                                                        <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  /></span>
                                                    </div>
                                                    <div className=' w-1/2    flex flex-row justify-center items-center  '>
                                                                <input  type="number" disabled value={needToken}   className='placeholder:text-[10px] w-full text-base text-white input1 text-right '  />
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        
                                        <div className='mt-3 mb-3 w-full flex flex-row justify-center'>
                                            <span className=' text-text1 text-[11px] leading-[11px]'>{t('pl.选择质押周期')}</span>
                                        </div>
                                            <div className="grid grid-cols-4 gap-2">
                                                {[0, 30, 90, 180].map((item) => {
                                                    const active = days === item;
                                                    return (
                                                    <div
                                                        key={item}
                                                        onClick={() => setDays(item)}
                                                        className={`
                                                        relative
                                                        h-[22px]
                                                        cursor-pointer
                                                        overflow-hidden
                                                        transition-all
                                                        duration-300
                                                        select-none
                                                        rounded-md
                                                        ${
                                                            active
                                                            ? "shadow-[0_0_18px_rgba(255,136,0,.55)]"
                                                            : ""
                                                        }
                                                        `}
                                                    
                                                    >
                                                        {/* 背景 */}
                                                        <div
                                                        className={`
                                                            absolute inset-0
                                                            ${
                                                            active
                                                                ? "bg-gradient-to-r from-[#ff6a00] via-[#ff9c00] to-[#ff6a00]"
                                                                : "bg-[#08111d]"
                                                            }
                                                        `}
                                                        />
                    
                                                        {/* 边框 */}
                                                        <div
                                                        className={`
                                                            absolute inset-0 border
                                                            ${
                                                            active
                                                                ? "border-[#ffb300]"
                                                                : "border-[#ff8c00]/40"
                                                            }
                                                        `}
                                                        />
                    
                                                        {/* 内容 */}
                                                        <div className="relative z-10 h-full flex flex-col items-center justify-center">
                                                        <div
                                                            className={`
                                                            text-[9px]  tracking-[1px]
                                                            ${
                                                                active
                                                                ? "text-white"
                                                                : "text-gray-400"
                                                            }
                                                            `}
                                                        >
                                                            {item==0?t('pl.自由'):item}
                                                        </div>
                    
                                                    
                                                        </div>
                    
                                                        {/* 激活光效 */}
                                                        {active && (
                                                        <div className="absolute inset-0 bg-white/10 animate-pulse" />
                                                        )}
                                                    </div>
                                                    );
                                                })}
                                                </div>
                    
                    
                                            <div className="w-full mt-3
                                                        relative inline-flex flex-col items-start justify-start
                                                        px-2 py-2 text-white text-[10px]  tracking-wider
                                                        [--cut:6px] [--border:1px]
                                                        before:absolute before:inset-0 before:bg-gray-800
                                                        before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                        after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                                        after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    ">
                                                <div className=' w-full flex flex-row justify-between items-center z-10'>
                                                    <div className=' flex flex-row justify-between items-center'>
                                                        <img className='mr-1 '  src={require('../../assets/task/icon1.png')} style={{"width":"10px"}}></img>
                                                        <span className='text-gray-400 text-[9px]'>{t('pl.日收益率')}</span>
                                                    </div>
                                                    <span className='text-gray-200 text-xs'>
                                                        {days==30?0.5:days==90?0.8:days==180?1.0:0.3}%
                                                    </span>
                                                </div>
                                                <div className=' w-full h-px bg-gray-800 mt-2 my-2 z-10'></div>
                                                <div className=' w-full flex flex-row justify-between items-center z-10'>
                                                    <div className=' flex flex-row justify-between items-center'>
                                                        <img className='mr-1 '  src={require('../../assets/task/icon2.png')} style={{"width":"10px"}}></img>
                                                        <span className='text-gray-400 text-[9px]'>{t('pl.加速算力')}</span>
                                                    </div>
                                                    <span className='text-gray-200 text-xs'>
                                                        {days==30?"1.5":days==90?"1.8":days==180?"2.0":"1.0"}X
                                                    </span>
                                                </div>
                                                <div className=' w-full h-px bg-gray-800 mt-2 my-2 z-10'></div>
                                            
                                                
                                        </div>
                                        <div className="flex justify-center w-full mt-3 mb-8">
                                            <button onClick={_rand} className="sci-glow-btn"> <span>{t('pl.质押')}</span></button>
                                        </div>
                    
                                    </div>
                                     {/*  */}
                                    
                                     
                                {/*  */}
                                </>
                            ):tab==1?(
                                <>
                                <div className='w-full my-2 flex flex-row justify-center items-center'>
                                        {/* <span className='text-text1 text-xs'>{t('pl.质押记录')}</span> */}
                                    
                                    </div>
                        
                                    
                                    {
                                    pledgeRecords2.length>0?
                                    pledgeRecords2.map((item,index)=>{
                                        return(
                                            <>
                                                <div className="mx-4  mt-4 py-5 px-5 pt-7 flex flex-col justify-start items-center SWAPbg1">    
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.质押')}</span>
                                                        {
                                                            item.pool_class == 2?(
                                                                <span className=' text-[10px] text-white'> <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.token}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2} />
                                                            &nbsp; SPACEX = $
                                                            <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.usdt}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2} />
                                                            </span>
                                                            ):(
                                                                <span className=' text-[10px] text-white'> <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.value}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2} />
                                                            &nbsp; BNB = $
                                                            <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.usdt}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2} />
                                                            </span>
                                                            )
                                                        }
                                                        
                                                    </div>
                                                
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.加速算力')}</span>
                                                        {
                                                            item.pool_class == 2?(
                                                                <span className=' text-[10px] text-white'> $<NumberFormat
                                                                    thousandsGroupStyle="thousand"
                                                                    value={item.all_bonus}
                                                                    prefix=""
                                                                    decimalSeparator="."
                                                                    displayType="text"
                                                                    type="text"
                                                                    thousandSeparator={true}
                                                                    allowNegative={false}
                                                                    fixedDecimalScale={true}
                                                                    decimalScale={2} /> / $<NumberFormat
                                                                    thousandsGroupStyle="thousand"
                                                                    value={item.max}
                                                                    prefix=""
                                                                    decimalSeparator="."
                                                                    displayType="text"
                                                                    type="text"
                                                                    thousandSeparator={true}
                                                                    allowNegative={false}
                                                                    fixedDecimalScale={true}
                                                                    decimalScale={2} />

                                                                        </span>
                                                            ):(
                                                                <span className=' text-[10px] text-text1'> <NumberFormat
                                                                    thousandsGroupStyle="thousand"
                                                                    value={item.all_bonus}
                                                                    prefix=""
                                                                    decimalSeparator="."
                                                                    displayType="text"
                                                                    type="text"
                                                                    thousandSeparator={true}
                                                                    allowNegative={false}
                                                                    fixedDecimalScale={true}
                                                                    decimalScale={2} /> BNB / <NumberFormat
                                                                    thousandsGroupStyle="thousand"
                                                                    value={item.max}
                                                                    prefix=""
                                                                    decimalSeparator="."
                                                                    displayType="text"
                                                                    type="text"
                                                                    thousandSeparator={true}
                                                                    allowNegative={false}
                                                                    fixedDecimalScale={true}
                                                                    decimalScale={2} /> BNB

                                                                        </span>
                                                            )
                                                        }
                                                        
                                                    </div>
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.已获收益')}</span>
                                                        <span className=' text-[10px] text-text1'><NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.jing}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={4} />
                                                            &nbsp; DOGE</span>
                                                    </div>
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.质押时间')}</span>
                                                        <span className=' text-[10px] text-white'><Moment format="YY-MM-DD HH:mm" unit="days" unix>{item.btime}</Moment></span>
                                                    </div>
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>

                                                    {
                                                        item.pool_class ==2?(
                                                            <>
                                                                <div className='w-full flex flex-row justify-between items-center'>
                                                                    <span className=' text-[9px] text-gray-400'>{t('pl.解锁时间')}</span>
                                                                    {
                                                                        item.days >0?(
                                                                            <span className=' text-[10px]  text-red-500'><Moment format="YY-MM-DD HH:mm" unit="days" unix>{item.etime}</Moment></span>
                                                                        ):(
                                                                            <span className=' text-[10px]  text-green-500'>{t('pl.自由')}</span>
                                                                        )
                                                                    }
                                                                    
                                                                </div>
                                                                <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                            </>
                                                        ):null
                                                    }
                                                    
                                                
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.我的状态')}</span>
                                                        {
                                                            item.state == 0?(
                                                                <span className=' text-[10px] text-green-500'>{t('pl.工作中')}</span>
                                                            ):(
                                                                <span className=' text-[10px] text-red-500'>{t('pl.已失效')}</span>
                                                            )
                                                        }
                                                        
                                                    </div>
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    {
                                                            item.state == 0 && item.pool_class ==2?(
                                                                <div className="flex justify-center w-full mt-1 mb-1">
                                                                    <button onClick={()=>hui(item.order_num,item.state,item.etime,item.path)} className="sci-glow-btn"> <span>{t('pl.赎回')}</span></button>
                                                                </div>
                                                            ):null
                                                        }
                                                    
                                                </div>
                                            
                                            </>
                                        )
                                    }):(
                                        
                                        <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-400 text-xs'>
                                                No data
                                        </div>
                                    )
                                }
                                </>
                            ):(
                                <>
                                <div className='mx-4  mt-3 pl-3 pr-3 pt-4 plbg1 min-h-[360px]  flex flex-col justify-start'>
                                        {/* <div className='w-full flex flex-row justify-center'>
                                            <span className='mt-1 text-text1 text-[11px] leading-[11px]'>{t('pl.质押')} $SPACEX</span>
                                        </div> */}
                                            
                                        
                                        <div className='mt-2 w-full flex flex-col items-center relative'>
                                            {/* <img className='-bottom-5  absolute z-[40]'  src={require('../../assets/ipo/arr.png')} style={{"width":"30px"}}></img> */}
                                            <div className="w-full min-h-[30px]
                                                    relative inline-flex flex-col h-4  justify-start 
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <div className='w-full z-10 flex flex-row justify-between items-center'>
                                                
                                                    <span className='text-[10px] leading-[10px] text-text1'>{t('pl.当前等级')}: </span>
                                                    <span className='text-[10px] leading-[10px] text-gray-200'>L{level} </span>
                                                </div>
                                            
                                            </div>
                                            <div className="w-full min-h-[30px] mt-2
                                                    relative inline-flex flex-col h-4  justify-start 
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <div className='w-full z-10 flex flex-row justify-between items-center'>
                                                
                                                    <span className='text-[10px] leading-[10px] text-text1'>{t('air.团队业绩')}: </span>
                                                    <span className='text-[10px] leading-[10px] text-gray-200'>$ <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={big}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /></span>
                                                </div>
                                            
                                            </div>
                                            <div className="w-full min-h-[30px] mt-2
                                                    relative inline-flex flex-col h-4  justify-start 
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <div className='w-full z-10 flex flex-row justify-between items-center'>
                                                
                                                    <span className='text-[10px] leading-[10px] text-text1'>{t('pl.小区业绩')}: </span>
                                                    <span className='text-[10px] leading-[10px] text-gray-200'>$ <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={small}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /></span>
                                                </div>
                                            
                                            </div>
                                            <div className="w-full min-h-[30px] mt-2
                                                    relative inline-flex flex-col h-4  justify-start 
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <div className='w-full z-10 flex flex-row justify-between items-center'>
                                                
                                                    <span className='text-[10px] leading-[10px] text-text1'>{t('pl.量化收益')}: </span>
                                                    <span className='text-[10px] leading-[10px] text-gray-200'><NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={jing}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /> DOGE</span>
                                                </div>
                                            
                                            </div>
                                            <div className="w-full min-h-[30px] mt-2
                                                    relative inline-flex flex-col h-4  justify-start 
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <div className='w-full z-10 flex flex-row justify-between items-center'>
                                                
                                                    <span className='text-[10px] leading-[10px] text-text1'>{t('pl.市场奖励')}: </span>
                                                    <span className='text-[10px] leading-[10px] text-gray-200'><NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={dong}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /> DOGE</span>
                                                </div>
                                            
                                            </div>
                                        </div>
                                    
                                    </div>
                                </>
                            )
                        }

                        
                        
        
                        
                       
                       
                                       
        
                        {/*  */}
                        
                        {/*  */}
                        <div className=' h-[200px]'></div>
                    </div>
                   
                    
                       
                   <Foot/>
        </>
    );
}

export default connect(mapStateToProps)(Staking);
